var _style, _defs, _path, _defs2, _rect, _defs3, _rect2, _defs4, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 156 128"
    },
    viewBox: "0 0 156 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;stroke:#CBCBCB;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#F7B600;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#1A1F71;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#1A1F71;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_1_"
  }))), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    xlinkHref: "#SVGID_1_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 10.7,
    id: "SVGID_3_",
    width: 117.3,
    x: 19.3,
    y: 88
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 20.7,
    width: 127.3,
    x: 14.3,
    y: 83
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 10.7,
    id: "SVGID_5_",
    width: 117.3,
    x: 19.3,
    y: 29.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_5_"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 20.7,
    width: 127.3,
    x: 14.3,
    y: 24.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.2,49.9l-6.1,28.7h-7.4l6.1-28.7H78.2z M109.6,68.4l3.9-10.8l2.3,10.8H109.6z M117.9,78.6h6.9l-6-28.7    h-6.4c-1.4,0-2.7,0.8-3.2,2.1L98,78.6h7.8l1.5-4.3h9.6L117.9,78.6z M98.5,69.2c0-7.6-10.5-8-10.4-11.4c0-1.1,1-2.1,3.2-2.4    c2.5-0.2,5.1,0.2,7.4,1.3l1.3-6.1c-2.2-0.9-4.6-1.3-7-1.3c-7.4,0-12.5,3.9-12.6,9.5c-0.1,4.2,3.7,6.4,6.5,7.8    c2.8,1.4,3.9,2.4,3.9,3.6c0,1.9-2.4,2.8-4.5,2.8c-2.7,0.1-5.3-0.6-7.7-1.8l-1.4,6.3c2.6,1.1,5.4,1.6,8.3,1.5    C93.3,79.1,98.4,75.2,98.5,69.2z M67.6,49.9L55.6,78.6h-7.9l-5.9-23c-0.4-1.4-0.7-1.9-1.7-2.5c-2.3-1.1-4.8-1.9-7.4-2.4l0.2-0.8    h12.7c1.7,0,3.2,1.3,3.4,3L52,69.4l7.7-19.6H67.6z",
    id: "SVGID_7_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_7_"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 39.7,
    width: 102.1,
    x: 27.7,
    y: 44.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3a8eaf1d617b53d533c49d4606ffca2a.svg";
export { ForwardRef as ReactComponent };